import { InscriptionFile } from "../inscription/InscriptionFile";

class MeritDocumentPostInscription extends InscriptionFile {
    private _newFile: boolean;
    private _inscriptionId: string;
    private _formFile: any;

    constructor(data: any) {
        super(data);
        this._newFile = data.newFile || false;
        this._inscriptionId = data.inscriptionId;
        this._formFile = data.formFile;
    }

    public toServer() {
        return {
            inscriptionId: this._inscriptionId,
            type: this.type,
            formFile: this._formFile,
            meritGroupId: this.meritGroupId,
            meritSubGroupId: this.meritSubGroupId,
            meritId: this.meritId,
        }
    }

    public get newFile(): boolean {
        return this._newFile;
    }
    public set newFile(newFile: boolean) {
        this._newFile = newFile;
    }
    
    public get inscriptionId(): string {
        return this._inscriptionId;
    }
    public set inscriptionId(inscriptionId: string) {
        this._inscriptionId = inscriptionId;
    }

    public get formFile(): any {
        return this._formFile;
    }
}

export { MeritDocumentPostInscription };